import React from 'react';

import type { PieDatum, PieFormat } from './Pie.types';

/**
 * PieLegend Component
 *
 * Renders a legend for a pie chart, showing color, label, and value for each slice.
 *
 * @component
 * @param {{ data: PieDatum[]; total: number; tooltipFormat: PieFormat }} props - Legend data and formatting.
 * @returns {JSX.Element}
 */
interface PieLegendProps {
  data: PieDatum[];
  total: number;
  tooltipFormat: PieFormat;
}

export const PieLegend: React.FC<PieLegendProps> = ({ data, total, tooltipFormat }) => (
  <div className="pie-legend pie-legend--below">
    <ul className="pie-legend-list">
      {data.map((item) => {
        let formattedValue = '';
        if (tooltipFormat === 'dollars') {
          formattedValue = `$${item.value.toLocaleString()}`;
        } else if (total > 0) {
          formattedValue = `${((item.value / total) * 100).toFixed(0)}%`;
        } else {
          formattedValue = '0%';
        }
        return (
          <li key={item.id} className="pie-legend-row">
            <span className="pie-legend-label">
              <span className="pie-legend-color pie-legend-color--small" style={{ background: item.color }} />
              <span>{item.label}</span>
            </span>
            <strong>{formattedValue}</strong>
          </li>
        );
      })}
    </ul>
  </div>
);
